const LOCAL_ENV_KEY = "LOCAL";
const DEV_ENV_KEY = "DEV";
const TEST_ENV_KEY = "TST";
const PROD_ENV_KEY = "PRO";

const Environments = {};

Environments[LOCAL_ENV_KEY] = {
	fullName: "Local",
	shortName: "Local"
};

Environments[DEV_ENV_KEY] = {
	fullName: "Development",
	shortName: "Dev"
};

Environments[TEST_ENV_KEY] = {
	fullName: "Test",
	shortName: "Test"
};

Environments[PROD_ENV_KEY] = {
	fullName: "Production",
	shortName: "Prod"
};

const m = {
	doesLocationHostMatch(regex) {
		return regex.test(location.host || location.hostname);
	},

	getCurrentEnvironmentKey() {
		if (this.doesLocationHostMatch(/^localhost/)) {
			return LOCAL_ENV_KEY;
		} else if (this.doesLocationHostMatch(/^10.10./)) {
			return LOCAL_ENV_KEY;
		} else if (this.doesLocationHostMatch(/^dev-/)) {
			return DEV_ENV_KEY;
		} else if (this.doesLocationHostMatch(/^dev\./)) {
			return DEV_ENV_KEY;
		} else if (this.doesLocationHostMatch(/^tst-/)) {
			return TEST_ENV_KEY;
		} else if (this.doesLocationHostMatch(/^test-/)) {
			return TEST_ENV_KEY;
		} else if (this.doesLocationHostMatch(/^tst\./)) {
			return TEST_ENV_KEY;
		} else if (this.doesLocationHostMatch(/^test\./)) {
			return TEST_ENV_KEY;
		} else {
			return PROD_ENV_KEY;
		}
	},

	getCurrentEnvironmentData() {
		// console.debug("env data", Environments);
		return Environments[this.getCurrentEnvironmentKey()];
	},

	getIsLocalEnvironment() {
		return this.getCurrentEnvironmentKey() === LOCAL_ENV_KEY;
	},

	getIsProductionEnvironment() {
		return this.getCurrentEnvironmentKey() === PROD_ENV_KEY;
	}
};

const isLocal = m.getIsLocalEnvironment();
const isProd = m.getIsProductionEnvironment();
const isProduction = isProd;

export { Environments, isLocal, isProd, isProduction };
export default m;
